import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Divider, Form, notification, Popconfirm } from "antd";
import { useGetColumnSearchProps } from "../../hooks/FilterTable/stringCLearFiltros";
import moment from "moment";
import { EditOutlined } from "@ant-design/icons";
import { IReqVotacoes } from "./interfaces";
import { BiTrash } from "react-icons/bi";
import VotacoesService from "../../services/http/services/VotacoesService";
import { EmitError } from "../../utils/EmitError";
import dayjs from "dayjs";
import { antdConvertDataSave } from "../../utils/Conversores";
import { isAfter, isBefore } from "date-fns";
import useAuth from "../../hooks/useAuth";

export default function useVotacoesManage() {

    const { userCan } = useAuth();

    const [form] = Form.useForm();
    const refForm = useRef<any>(null);

    const refController = useRef(new AbortController());
    const refIdEditarVotacao = useRef<any>(null);

    const [viewScreenAlternativas, setViewScreenAlternativas] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditarVotacao, setIsEditarVotacao] = useState(false);

    const refFuncaoLimparFiltrosString = useRef<any>(null);
    const refContagemDoFiltroMembros = useRef<Array<any>>([]);

    const [loadingPage, setLoadingPage] = useState(false);
    const [loadindTable, setLoadindTable] = useState(false);
    const [dataReq, setDataReq] = useState<Array<IReqVotacoes>>([]);

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string | number>>([]);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);

    const refDataEntity = useRef<any>(
        JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null
    );

    const refFormSelectCargos = useRef<any>(null);
    const refBotaoSeleCargos = useRef<any>(null);
    const [dadosCargosList, setDadosCargosList] = useState<Array<any>>([]);

    const [isModalOpenResultadoVotacoes, setIsModalOpenResultadoVotacoes] = useState(false);

    const [defaultValueDatePickerInicio, onDefaultValueDatePickerInicio] = useState<Date>();
    const [defaultValueDatePickerFim, onDefaultValueDatePickerFim] = useState<Date>();

    const getVotacoes = useCallback(() => {
        const requestAsync = async () => {
            try {
                setLoadindTable(true);

                const data = await VotacoesService.getVotacoes(refDataEntity.current?.entity?.id, refController.current.signal);

                setDataReq(data);

                setLoadindTable(false);
            } catch (error) {
                setLoadindTable(false);

                EmitError(error, true, "useEffect");
            }
        };
        return requestAsync();
    }, []);

    //setando dados das cidades no selected
    const getCargos = useCallback(() => {

        const requestAsync = async () => {
            try {

                const data = await VotacoesService.getCargo(refController.current.signal);

                setDadosCargosList(data);

                return true;

            } catch (error) {
                EmitError(error, true, "useEffect");

                return false
            }
        }

        return requestAsync();

    }, []);

    useEffect(() => {
        return () => {
            refController.current.abort();
        }
    }, []);

    useEffect((): void => {

        const buscaDadosIniciais = async () => {
            try {
                refController.current = new AbortController();

                if (userCan('manage_voting')) {

                    getVotacoes();

                    getCargos();

                }

                setLoadingPage(false);
            } catch (error) {
                setLoadingPage(false);
                notification.error({
                    message: "Erro",
                    description: "Não foi possivel buscar dados!",
                });
            }
        };

        buscaDadosIniciais();

    }, []);

    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.id)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.id
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.id]);
                setHasSelectedEdit(true);
            } else {
                let teste = selectedRowKeys.concat(record.id);
                setSelectedRowKeys(teste);
                setHasSelectedEdit(false);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    // const onSelectChange = useCallback((selectedRowKeys: any): void => {
    const onSelectChange = useCallback((selectedRowKeys: Array<string | number>, selectedRows: Array<any>): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(true);
        }
    }, [selectedRowKeys]);


    const rowSelection: any = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const columns = [
        // {
        //     title: "Foto",
        //     dataIndex: "foto",
        //     width: "10%",
        //     render: (foto: any) => {
        //         return (
        //             <img
        //                 src={
        //                     foto !== " "
        //                         ? urlImgMembros + "/" + foto
        //                         : "/default-avatar.png"
        //                 }
        //                 alt="Foto"
        //                 onClick={() => {
        //                     setImagemModal(urlImgMembros + "/" + foto);
        //                     setIsModalImagemOpen(true);
        //                 }}
        //                 style={{
        //                     width: 50,
        //                     height: 50,
        //                     borderRadius: 5,
        //                     cursor: "pointer",
        //                 }}
        //             />
        //         );
        //     },
        // },
        {
            title: "Título",
            dataIndex: "titulo",
            width: "20%",
            sorter: (a: any, b: any) => a?.titulo?.localeCompare(b?.titulo),
            ...useGetColumnSearchProps("titulo", refFuncaoLimparFiltrosString),
            showSorterTooltip: false,
        },
        {
            title: "Descrição",
            dataIndex: "descricao",
            width: "20%",
            sorter: (a: any, b: any) => a?.descricao?.localeCompare(b?.descricao),
            ...useGetColumnSearchProps("descricao", refFuncaoLimparFiltrosString),
            showSorterTooltip: false,
        },
        {
            title: "Data início",
            dataIndex: "dataInicio",
            width: "15%",
            showSorterTooltip: false,
            sorter: (a: any, b: any) =>
                a.dataInicio.localeCompare(b.dataInicio),
            render: (criado: any) => moment(criado).format("DD/MM/YYYY HH:mm"),
        },
        {
            title: "Data fim",
            dataIndex: "dataFim",
            width: "15%",
            showSorterTooltip: false,
            sorter: (a: any, b: any) =>
                a.dataFim.localeCompare(b.dataFim),
            render: (criado: any) => moment(criado).format("DD/MM/YYYY HH:mm"),
        },
        {
            title: "Criado em",
            dataIndex: "created_at",
            width: "15%",
            showSorterTooltip: false,
            sorter: (a: any, b: any) =>
                a.created_at.localeCompare(b.created_at),
            render: (criado: any) => moment(criado).format("DD/MM/YYYY HH:mm"),
        },
        {
            title: "Ações",
            dataIndex: "id",
            width: "10%",
            render: (id: any, record: any) => (
                <span>
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        size="small"
                        onClick={(e) => {
                            e?.stopPropagation();

                            setLoadingPage(true);
                            setIsEditarVotacao(true);
                            refIdEditarVotacao.current = id

                            handleShowModal();

                            let dtInicio = null
                            if (record.dataInicio) {
                                onDefaultValueDatePickerInicio(new Date(record.dataInicio))
                                dtInicio = dayjs(record.dataInicio)
                            }

                            let dtFim = null
                            if (record.dataFim) {
                                onDefaultValueDatePickerFim(new Date(record.dataFim))
                                dtFim = dayjs(record.dataFim)
                            }

                            setTimeout(() => {

                                // Carrega os dados da noticia com block
                                refForm.current?.setFieldsValue({
                                    dataFim: dtFim,
                                    dataInicio: dtInicio,
                                    descricao: record.descricao,
                                    titulo: record.titulo,
                                    cargosPermitidosIds: record.cargosPermitidos,
                                });

                                setLoadingPage(false)
                            }, 1000);


                        }}
                    >
                        <EditOutlined />
                    </Button>
                    <Divider type="vertical" />
                    <Popconfirm
                        title="Deseja realmente excluir?"
                        onConfirm={(e) => {
                            e?.stopPropagation();

                            excluirVotacao(id);
                        }}
                        onCancel={(e) => {
                            e?.stopPropagation();
                        }}
                        okText="Sim"
                        cancelText="Não"
                    >
                        <Button
                            style={{
                                borderRadius: 5,
                                margin: 1,
                            }}
                            type="primary"
                            danger
                            size="small"
                            onClick={(e) => {
                                e?.stopPropagation();
                            }}
                        >
                            <BiTrash />
                        </Button>
                    </Popconfirm>
                </span>
            ),
        },
    ]

    const handleCancelModalResultadoVotacoes = useCallback(() => {

        setIsModalOpenResultadoVotacoes(false);
    }, [])

    const handleShowModalResultadoVotacoes = useCallback(() => {
        setIsModalOpenResultadoVotacoes(true);
    }, [])

    const handleCancelModal = useCallback(() => {
        refForm.current?.resetFields();

        refIdEditarVotacao.current = null

        setIsModalOpen(false);
    }, [])

    const handleShowModal = useCallback(() => {
        setIsModalOpen(true);
    }, [])

    const onClickBotaoSalvarModal = useCallback((): void => {

        const requestAsync = async (obj: any) => {
            try {
                setLoadingPage(true);
                setLoadindTable(true);

                await VotacoesService.postVotacoes(
                    refDataEntity.current?.entity?.id,
                    obj,
                    refController.current.signal
                );

                getVotacoes();

                setLoadingPage(false);
                setLoadindTable(false);

                handleCancelModal();
            } catch (error) {

                setLoadingPage(false);
                setLoadindTable(false);

                EmitError(error, true, "useEffect");
            }
        };

        refForm.current
            .validateFields()
            .then((values: any) => {

                const dtIni = antdConvertDataSave(values.dataInicio, true)
                const dtFim = antdConvertDataSave(values.dataFim, true)

                // validar se a data inicial não poder maior que a data final
                const resultado = isAfter(dtIni!, dtFim!)

                if (resultado) {
                    notification.error({
                        message: 'Data inválida.',
                        description:
                            'A data inicial não pode ser posterior à data final.',
                    });
                    return
                }

                values.dataInicio = antdConvertDataSave(values.dataInicio, true)
                values.dataFim = antdConvertDataSave(values.dataFim, true)

                requestAsync(values);

            })
            .catch((errorInfo: any) => {

                setLoadindTable(false);
                setLoadingPage(false);
                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });

            });

    }, []);

    const onClickBotaoEditarModal = useCallback((): void => {

        const requestAsync = async (obj: any) => {
            try {
                setLoadingPage(true);
                setLoadindTable(true);

                await VotacoesService.putVotacoes(
                    refDataEntity.current?.entity?.id,
                    refIdEditarVotacao.current,
                    obj,
                    refController.current.signal
                );

                getVotacoes();

                setLoadingPage(false);
                setLoadindTable(false);

                handleCancelModal();
            } catch (error) {

                setLoadingPage(false);
                setLoadindTable(false);

                EmitError(error, true, "useEffect");
            }
        };


        refForm.current
            .validateFields()
            .then((values: any) => {

                const dtIni = antdConvertDataSave(values.dataInicio, true)
                const dtFim = antdConvertDataSave(values.dataFim, true)

                // validar se a data inicial não poder maior que a data final
                const resultado = isAfter(dtIni!, dtFim!)

                if (resultado) {
                    notification.error({
                        message: 'Data inválida.',
                        description:
                            'A data inicial não pode ser posterior à data final.',
                    });
                    return
                }

                values.dataInicio = dtIni
                values.dataFim = dtFim

                requestAsync(values);

            })
            .catch((errorInfo: any) => {

                setLoadingPage(false);
                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });

            });

    }, []);


    const excluirVotacao = useCallback((id: any): void => {

        const requestAsync = async () => {
            try {
                setLoadingPage(true);
                setLoadindTable(true);


                await VotacoesService.deleteVotacoes(
                    refDataEntity.current?.entity?.id,
                    id,
                    refController.current.signal
                );

                getVotacoes();

            } catch (error) {

                setLoadingPage(false);
                setLoadindTable(false);

                EmitError(error, true, "useEffect");
            }
        };

        requestAsync();

    }, []);

    const onClickAddTodosSeleCargos = useCallback(() => {

        let arrayIds: any = [];
        dadosCargosList.forEach((val: any) => {
            arrayIds.push(val.id);
        });

        refForm.current.setFieldsValue(
            { cargosPermitidosIds: arrayIds }
        );

        refBotaoSeleCargos.current?.blur();
        refFormSelectCargos.current?.blur();

    }, [dadosCargosList]);

    return {
        loadindTable,
        refContagemDoFiltroMembros,
        dataReq,
        columns,
        form,
        isModalOpen,
        handleCancelModal,
        refForm,
        loadingPage,
        onClickBotaoSalvarModal,
        onClickBotaoEditarModal,
        isEditarVotacao,
        setIsEditarVotacao,
        handleShowModal,
        rowSelection,
        onclickTable,
        refFormSelectCargos,
        refBotaoSeleCargos,
        dadosCargosList,
        onClickAddTodosSeleCargos,
        hasSelectedEdit,
        selectedRowKeys,
        setViewScreenAlternativas,
        viewScreenAlternativas,
        isModalOpenResultadoVotacoes,
        handleCancelModalResultadoVotacoes,
        handleShowModalResultadoVotacoes,
        refDataEntity,
        defaultValueDatePickerInicio,
        defaultValueDatePickerFim,
        userCan,
    }
}
